// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors"], function() { return __webpack_require__("./src/scripts/base.ts"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], function() { return __webpack_require__("./src/styles/base.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
